import {
  WebPanel,
  WebPanelItem,
  WebPanelItemAction,
  WebPanelItemContent,
  WebPanelItemLabel,
} from '@/components/web-panel'
import Link from '@/update-monitor/Link'
import type { Maybe } from '@/utils/common-types'
import { formatDateJP } from '@/utils/date-helpers'
import { FragmentOf, graphql, readFragment } from 'gql.tada'
import {
  PaymentMethodPanelItem,
  PaymentMethodPanelItem_viewer,
} from './PaymentSettings/PaymentMethodPanelItem'

import IconRight from '@/assets/icons/ic_logic-g-app_arrow-right.svg'

interface Props {
  viewer: null | undefined | FragmentOf<typeof PaymentInfo_viewer>
}

export function PaymentSettings(props: Props) {
  const viewer = readFragment(PaymentInfo_viewer, props.viewer)

  return (
    <section className="mx-auto max-w-[940px]">
      <h3 className="mb-2.5 text-base font-bold md:mb-3.5 md:text-[17px] lg:mb-5 lg:text-xl">
        支払い情報
      </h3>
      <WebPanel>
        <PaymentMethodPanelItem viewer={viewer} />

        <WebPanelItem>
          <WebPanelItemLabel>支払い</WebPanelItemLabel>

          <WebPanelItemContent>
            <PaymentDate
              paymentDate={viewer?.latestPaymentDate}
              hasCurriculumLicense={viewer?.hasCurriculumLicense}
              hasSubscription={viewer?.hasSubscription}
            />
          </WebPanelItemContent>

          <WebPanelItemAction>
            <Link
              href={{
                pathname: '/web/payment-history/[userId]',
                query: { userId: viewer?.id },
              }}
              className="flex items-center"
            >
              <span className="text-[13px] font-bold text-primary-100 md:text-[15px]">
                支払い履歴
              </span>
              <IconRight
                width={26}
                className="-ml-1 inline text-primary-100 md:ml-0 md:w-[30px]"
              />
            </Link>
          </WebPanelItemAction>
        </WebPanelItem>
      </WebPanel>
    </section>
  )
}

function PaymentDate({
  paymentDate,
  hasCurriculumLicense,
  hasSubscription,
}: {
  paymentDate: string | null | undefined
  hasCurriculumLicense: Maybe<boolean>
  hasSubscription: Maybe<boolean>
}) {
  const hasOnlyCurriculumLicense = hasCurriculumLicense && !hasSubscription

  return (
    <div className="text-secondary-text">
      <p className="text-[13px] font-bold md:text-[14px] lg:text-[15px]">
        {hasOnlyCurriculumLicense
          ? 'なし'
          : paymentDate
            ? formatDateJP(paymentDate)
            : 'なし'}
      </p>
    </div>
  )
}

export const PaymentInfo_viewer = graphql(
  `
    fragment PaymentInfo_viewer on User {
      id
      latestPaymentDate
      hasCurriculumLicense
      hasSubscription
      ...PaymentMethodPanelItem_viewer
    }
  `,
  [PaymentMethodPanelItem_viewer]
)
